import { CALCULATOR_PARKING_TYPES } from "constants/calculator";

export const getParkingTypeName = (parkingType: string, t: any) => {
  switch (parkingType) {
    case CALCULATOR_PARKING_TYPES.PARKING_UNDERGROUND:
      return t("calculator_form.invest_objects.parking_space_underground");
    case CALCULATOR_PARKING_TYPES.PARKING_GARAGE:
      return t("calculator_form.invest_objects.parking_space_garage");
    case CALCULATOR_PARKING_TYPES.PARKING_OUTDOOR:
      return t("calculator_form.invest_objects.parking_space_outdoor");
    default:
      return t("calculator_form.invest_objects.parking");
  }
};
